// Company Profile client — /api/v1/platform/company-profile (website plan §6.2).
//
// ADMIN reads, SUPER_ADMIN writes — enforced by the controller; the page only
// decides whether to render the form read-only.

import { apiClient } from '@/lib/api-client';
import type { CompanyProfile, UpdateCompanyProfileInput } from '@/types/company-profile';

const BASE = '/platform/company-profile';

export const companyProfileService = {
  get() {
    return apiClient<CompanyProfile>(BASE);
  },

  update(input: UpdateCompanyProfileInput) {
    return apiClient<CompanyProfile>(BASE, { method: 'PUT', body: input });
  },
};
